import(/* webpackMode: "eager", webpackExports: ["ArticleHeroActions"] */ "/vercel/path0/components/article/ArticleHeroActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CitationsRail"] */ "/vercel/path0/components/article/CitationsRail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/vercel/path0/components/article/ReadingProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/vercel/path0/components/article/TableOfContents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleReadTracker"] */ "/vercel/path0/components/ArticleReadTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResearchCTA"] */ "/vercel/path0/components/cta/ResearchCTA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
